/* Elixir Skincare Co. — Crown Club storefront behavior (matches prototype)
   Shopify AJAX cart, drawers, Crown Club (/apps/crown), ASMR swipe check-in, FAQ. */
(function(){
  "use strict";
  var PROXY = "/apps/crown";
  var TIERS = [
    {crowns:50,  name:"Bronze", title:"30% off"},
    {crowns:150, name:"Silver", title:"$10 off"},
    {crowns:250, name:"Gold",   title:"Free dropper"}
  ];
  var RING_C = 2 * Math.PI * 92;
  var $  = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var money = function(cents){return "$" + (cents/100).toFixed(2);};

  function openEl(id){var e=$(id);if(e)e.classList.add("open");}
  function closeAll(){$$(".elx-scrim,.elx-drawer").forEach(function(e){e.classList.remove("open");});}
  function bindDrawers(){
    $$("[data-elx-open-menu]").forEach(function(b){b.addEventListener("click",function(){openEl("#elx-scrim-menu");openEl("#elx-menu");});});
    $$("[data-elx-open-cart]").forEach(function(b){b.addEventListener("click",function(e){e.preventDefault();openEl("#elx-scrim-cart");openEl("#elx-cart");renderCart();});});
    $$("[data-elx-close]").forEach(function(b){b.addEventListener("click",closeAll);});
  }

  function getCart(){return fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();});}
  function addToCart(variantId,btn){
    if(!variantId){return;}
    var label=btn?btn.textContent:""; if(btn){btn.textContent="Adding…";}
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({items:[{id:variantId,quantity:1}]})})
      .then(function(r){return r.json();})
      .then(function(){if(btn){btn.textContent="Added ✓";setTimeout(function(){btn.textContent=label||"Add to bag";},1200);}
        openEl("#elx-scrim-cart");openEl("#elx-cart");return renderCart();})
      .catch(function(){if(btn){btn.textContent=label||"Add to bag";}});
  }
  function changeLine(key,qty){
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart);
  }
  function renderCart(){
    return getCart().then(function(cart){
      $$("[data-elx-cart-count]").forEach(function(e){e.textContent=cart.item_count;e.style.display=cart.item_count>0?"flex":"none";});
      var wrap=$("#elx-cart-items"), empty=$("#elx-cart-empty"), foot=$("#elx-cart-foot");
      if(!wrap)return;
      if(cart.item_count===0){ if(empty)empty.classList.remove("elx-hide"); wrap.innerHTML=""; if(foot)foot.classList.add("elx-hide"); return; }
      if(empty)empty.classList.add("elx-hide");
      if(foot)foot.classList.remove("elx-hide");
      wrap.innerHTML=cart.items.map(function(it){
        var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,"_120x$1$2"):"";
        return '<div style="display:flex;gap:13px;align-items:center;padding:14px 0;border-bottom:1px solid #ece0c8;">'+
          '<div style="flex:none;width:64px;height:64px;border-radius:11px;background-image:url(\''+img+'\');background-size:cover;background-position:center;"></div>'+
          '<div style="flex:1;min-width:0;">'+
            '<div style="font-family:Fraunces,serif;font-size:15px;color:#241C12;line-height:1.2;">'+it.product_title+'</div>'+
            '<div style="font-family:\'Space Grotesk\',monospace;font-size:11px;color:#8a7559;margin:2px 0 8px;">'+(it.variant_title&&it.variant_title!=="Default Title"?it.variant_title+" · ":"")+money(it.price)+'</div>'+
            '<div style="display:inline-flex;align-items:center;border:1px solid #dccba0;border-radius:100px;overflow:hidden;">'+
              '<button data-key="'+it.key+'" data-q="'+(it.quantity-1)+'" class="elx-qty" style="background:none;border:none;cursor:pointer;width:28px;height:28px;color:#5A4A36;font-size:16px;">−</button>'+
              '<span style="font-family:\'Space Grotesk\',monospace;font-size:13px;min-width:22px;text-align:center;color:#241C12;">'+it.quantity+'</span>'+
              '<button data-key="'+it.key+'" data-q="'+(it.quantity+1)+'" class="elx-qty" style="background:none;border:none;cursor:pointer;width:28px;height:28px;color:#5A4A36;font-size:16px;">+</button>'+
            '</div>'+
          '</div>'+
          '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px;">'+
            '<span style="font-family:\'Space Grotesk\',monospace;font-size:14px;font-weight:600;color:#241C12;">'+money(it.final_line_price)+'</span>'+
            '<button data-key="'+it.key+'" data-q="0" class="elx-qty" style="background:none;border:none;cursor:pointer;font-family:\'Space Grotesk\',monospace;font-size:10px;letter-spacing:.5px;color:#a8957a;text-transform:uppercase;">Remove</button>'+
          '</div>'+
        '</div>';
      }).join("");
      var sub=$("#elx-cart-subtotal"); if(sub)sub.textContent=money(cart.total_price);
      var cc=$("#elx-cart-crowns"); if(cc){var earn=Math.round(cart.total_price/100*2);cc.textContent="You'll earn "+earn+" crown"+(earn===1?"":"s")+" with this order";}
      $$(".elx-qty",wrap).forEach(function(b){b.addEventListener("click",function(){changeLine(b.getAttribute("data-key"),parseInt(b.getAttribute("data-q"),10));});});
    });
  }
  function bindCart(){
    $$("[data-elx-add]").forEach(function(b){b.addEventListener("click",function(){addToCart(b.getAttribute("data-variant-id"),b);});});
    $$("[data-elx-checkout]").forEach(function(b){b.addEventListener("click",function(){window.location.href="/checkout";});});
    renderCart();
  }

  function nextTier(crowns){for(var i=0;i<TIERS.length;i++){if(crowns<TIERS[i].crowns)return {t:TIERS[i],i:i};}return {t:TIERS[TIERS.length-1],i:TIERS.length-1,done:true};}
  function animateCount(el,from,to){var t0=performance.now();function step(t){var k=Math.min((t-t0)/800,1);var e=1-Math.pow(1-k,3);el.textContent=Math.round(from+(to-from)*e);if(k<1)requestAnimationFrame(step);}requestAnimationFrame(step);}
  function sparkle(){var box=$("#elx-ring-spark");if(!box)return;for(var k=0;k<18;k++){(function(){var s=document.createElement("span");s.className="elx-spark";box.appendChild(s);var a=Math.random()*Math.PI*2,d=55+Math.random()*70,ms=750+Math.random()*600;s.animate([{transform:"translate(-50%,-50%) scale(1)",opacity:1},{transform:"translate("+(Math.cos(a)*d-50)+"%,"+(Math.sin(a)*d-50)+"%) scale(0)",opacity:0}],{duration:ms,easing:"cubic-bezier(.2,.7,.3,1)"});setTimeout(function(){s.remove();},ms);})();}}

  var STATE=null;
  function renderState(s,animate){
    STATE=s;
    $$("[data-elx-balance]").forEach(function(e){e.textContent=s.crowns;});
    var hb=$("#elx-header-balance"); if(hb) hb.textContent = s.signedIn ? s.crowns : "Sign in";
    var nt=nextTier(s.crowns);
    var prev=nt.i>0?TIERS[nt.i-1].crowns:0;
    var pct=nt.done?1:Math.min((s.crowns-prev)/(nt.t.crowns-prev),1);
    var fg=$("#elx-ring-fg");
    if(fg){fg.setAttribute("stroke-dasharray",RING_C);fg.style.strokeDashoffset=(RING_C*(1-pct))+"px";}
    var cnt=$("#elx-ring-count");
    if(cnt){if(animate)animateCount(cnt,Math.max(s.crowns-(s.awarded||0),0),s.crowns);else cnt.textContent=s.crowns;}
    var sub=$("#elx-ring-sub");
    if(sub){
      if(nt.done) sub.textContent="All rewards unlocked";
      else if(s.signedIn) sub.textContent=(s.streak||0)+" day streak · "+(nt.t.crowns-s.crowns)+" to "+nt.t.name;
      else sub.textContent=(nt.t.crowns-s.crowns)+" crowns to "+nt.t.title.toLowerCase();
    }
    toggle("#elx-signedout", !s.signedIn);
    toggle("#elx-swipe", s.signedIn && !s.checkedIn);
    toggle("#elx-claimed", s.signedIn && s.checkedIn);
    var tc=$("#elx-tiers");
    if(tc){tc.innerHTML=TIERS.map(function(t){
      var on=s.crowns>=t.crowns;
      var isNext=(!on && t.crowns===nt.t.crowns && !nt.done);
      var lit=on||isNext;
      var border=lit?"1px solid rgba(240,215,154,.55)":"1px solid rgba(240,215,154,.14)";
      var crownColor=lit?"#F0D79A":"rgba(240,215,154,.5)";
      var pillBg=lit?"rgba(240,215,154,.16)":"rgba(251,246,236,.05)";
      var pillColor=lit?"#F0D79A":"rgba(251,246,236,.5)";
      var status=on?"Unlocked":(isNext?"Next up":"Locked");
      return '<div style="background:rgba(251,246,236,.04);border-radius:15px;padding:13px 11px;text-align:center;border:'+border+';">'+
        '<div style="font-family:\'Space Grotesk\',monospace;font-size:20px;font-weight:700;line-height:1;margin-bottom:7px;color:'+crownColor+';">'+t.crowns+'</div>'+
        '<div style="font-size:12px;line-height:1.25;color:#FBF6EC;font-weight:700;min-height:30px;">'+t.title+'</div>'+
        '<div style="margin-top:9px;font-family:\'Space Grotesk\',monospace;font-size:9.5px;letter-spacing:.6px;text-transform:uppercase;padding:4px 0;border-radius:100px;background:'+pillBg+';color:'+pillColor+';">'+status+'</div>'+
      '</div>';
    }).join("");}
    var gp=Math.min(s.crowns/250*100,100);
    var gf=$("#elx-gold-fill"); if(gf)gf.style.width=gp+"%";
    var gl=$("#elx-gold-label"); if(gl)gl.textContent=(s.crowns>=250?"Unlocked":s.crowns+" / 250 crowns · "+(250-s.crowns)+" to go");
  }
  function toggle(sel,show){var e=$(sel);if(e)e.classList.toggle("elx-hide",!show);}

  function loadState(){
    fetch(PROXY+"/state",{headers:{"Accept":"application/json"},credentials:"same-origin"})
      .then(function(r){if(!r.ok)throw 0;return r.json();})
      .then(function(s){renderState(s,false);})
      .catch(function(){
        var root=$("#elx-crownclub");
        var demo=root?parseInt(root.getAttribute("data-demo-crowns")||"38",10):38;
        var loggedIn=root && root.getAttribute("data-logged-in")==="1";
        renderState({signedIn:loggedIn,crowns:demo,streak:7,checkedIn:false,awarded:0,demo:true},false);
      });
  }
  function bindLogin(){
    var b=$("#elx-login-btn"); if(!b)return;
    b.addEventListener("click",function(){
      var c=$("#elx-consent");
      if(c && !c.checked){
        var lbl=c.closest("label"); if(lbl){lbl.animate([{opacity:.35},{opacity:1}],{duration:420});}
        if(c.focus)c.focus();
        return;
      }
      var url=b.getAttribute("data-login-url")||"/account/login";
      window.location.href=url;
    });
  }
  function sizeTopbar(){var t=$("#elx-topbar"),sp=$("#elx-topbar-spacer");if(t&&sp)sp.style.height=t.offsetHeight+"px";}
  function checkIn(){
    if(STATE&&STATE.demo){ STATE.crowns+=2; STATE.checkedIn=true; STATE.awarded=2; sparkle(); renderState(STATE,true); return; }
    fetch(PROXY+"/checkin",{method:"POST",headers:{"Accept":"application/json"},credentials:"same-origin"})
      .then(function(r){return r.json();}).then(function(s){if(s&&s.ok){sparkle();renderState(s,true);}}).catch(function(){});
  }

  /* ASMR swipe — easy for finger and mouse: drag with a forgiving 70% threshold,
     or just click/tap the track and the crown glides home. */
  function bindSwipe(){
    var track=$("#elx-swipe-track"), knob=$("#elx-swipe-knob"), fill=$("#elx-swipe-fill");
    if(!track||!knob)return;
    var dragging=false, offset=0, done=false;
    function maxX(){return track.clientWidth-knob.clientWidth-6;}
    function place(x){x=Math.max(6,Math.min(x,maxX()));knob.style.left=x+"px";if(fill)fill.style.width=(x+knob.clientWidth/2)+"px";return x;}
    function glide(){knob.style.transition="left .45s cubic-bezier(.2,.9,.25,1)";if(fill)fill.style.transition="width .45s cubic-bezier(.2,.9,.25,1)";return place(maxX());}
    function reset(){knob.style.transition="left .35s cubic-bezier(.3,.9,.3,1)";if(fill)fill.style.transition="width .35s cubic-bezier(.3,.9,.3,1)";place(6);}
    function complete(){if(done)return;done=true;glide();setTimeout(checkIn,260);}
    function cx(e){return e.touches?e.touches[0].clientX:e.clientX;}
    function down(e){if(done)return;dragging=true;offset=cx(e)-knob.offsetLeft;knob.style.transition="";if(fill)fill.style.transition="";}
    function move(e){if(!dragging||done)return;place(cx(e)-offset);}
    function up(){if(!dragging||done)return;dragging=false;if(knob.offsetLeft>=maxX()*0.7)complete();else reset();}
    knob.addEventListener("mousedown",down);window.addEventListener("mousemove",move);window.addEventListener("mouseup",up);
    knob.addEventListener("touchstart",down,{passive:true});window.addEventListener("touchmove",move,{passive:true});window.addEventListener("touchend",up);
    track.addEventListener("click",function(e){if(done||dragging||e.target===knob)return;complete();});
  }

  function bindFaq(){
    $$(".elx-faq").forEach(function(item){
      var btn=$(".elx-faq-btn",item), ans=$(".elx-faq-a",item);
      if(!btn||!ans)return;
      btn.addEventListener("click",function(){
        var open=item.classList.toggle("open");
        ans.style.maxHeight=open?ans.scrollHeight+"px":0;
      });
    });
  }

  /* Move scrims + drawers into a column-width clipping stage so they open
     "inside the page" and the sides show the storefront. */
  function wrapDrawers(){
    if($("#elx-drawer-stage"))return;
    var nodes=$$(".elx-scrim,.elx-drawer");
    if(!nodes.length)return;
    var stage=document.createElement("div"); stage.id="elx-drawer-stage";
    nodes[0].parentNode.appendChild(stage);
    nodes.forEach(function(n){stage.appendChild(n);});
  }
  /* Add a Sign out link to the menu when a customer is signed in. */
  function injectSignOut(){
    var root=$("#elx-crownclub");
    if(!root || root.getAttribute("data-logged-in")!=="1")return;
    var nav=$("#elx-menu nav"); if(!nav || $("#elx-signout",nav))return;
    var a=document.createElement("a"); a.id="elx-signout"; a.href="/account/logout"; a.textContent="Sign out";
    a.setAttribute("style","font-family:'Fraunces',serif;font-weight:300;font-size:26px;color:#A8551F;text-decoration:none;padding:14px 0;border-top:1px solid #f1e7d2;margin-top:6px;");
    nav.appendChild(a);
  }

  document.addEventListener("DOMContentLoaded",function(){
    wrapDrawers();injectSignOut();
    bindDrawers();bindCart();bindSwipe();bindFaq();bindLogin();loadState();
    sizeTopbar();window.addEventListener("resize",sizeTopbar);
  });
})();
